import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public APIs
export const submitForm = async (data) => {
  const response = await api.post('/forms/submit', data);
  return response.data;
};

export const getProducts = async () => {
  const response = await api.get('/products');
  return response.data;
};

// Admin Auth APIs
export const adminLogin = async (email, password) => {
  const response = await api.post('/admin/login', { email, password });
  return response.data;
};

export const adminRegister = async (email, password, adminCode) => {
  const response = await api.post('/admin/register', { email, password, admin_code: adminCode });
  return response.data;
};

// Admin Protected APIs
export const getStats = async () => {
  const response = await api.get('/admin/stats');
  return response.data;
};

export const getSubmissions = async (formType = null, status = null) => {
  const params = new URLSearchParams();
  if (formType) params.append('form_type', formType);
  if (status) params.append('status', status);
  const response = await api.get(`/admin/submissions?${params.toString()}`);
  return response.data;
};

export const updateSubmissionStatus = async (id, newStatus) => {
  const response = await api.patch(`/admin/submissions/${id}/status?new_status=${newStatus}`);
  return response.data;
};

export const deleteSubmission = async (id) => {
  const response = await api.delete(`/admin/submissions/${id}`);
  return response.data;
};

// Product Management APIs
export const createProduct = async (data) => {
  const response = await api.post('/admin/products', data);
  return response.data;
};

export const updateProduct = async (id, data) => {
  const response = await api.put(`/admin/products/${id}`, data);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await api.delete(`/admin/products/${id}`);
  return response.data;
};

export const seedProducts = async () => {
  const response = await api.post('/admin/seed-products');
  return response.data;
};

// Site Settings APIs
export const getSettings = async () => {
  const response = await api.get('/settings');
  return response.data;
};

export const getAdminSettings = async () => {
  const response = await api.get('/admin/settings');
  return response.data;
};

export const updateSettings = async (data) => {
  const response = await api.put('/admin/settings', data);
  return response.data;
};

// Payment APIs
export const confirmPayment = async (data) => {
  const response = await api.post('/payments/confirm', data);
  return response.data;
};

export const getPayments = async (status = null, paymentType = null) => {
  const params = new URLSearchParams();
  if (status) params.append('status', status);
  if (paymentType) params.append('payment_type', paymentType);
  const response = await api.get(`/admin/payments?${params.toString()}`);
  return response.data;
};

export const updatePaymentStatus = async (id, newStatus) => {
  const response = await api.patch(`/admin/payments/${id}/status?new_status=${newStatus}`);
  return response.data;
};

export const deletePayment = async (id) => {
  const response = await api.delete(`/admin/payments/${id}`);
  return response.data;
};

export const getPaymentStats = async () => {
  const response = await api.get('/admin/payments/stats');
  return response.data;
};

// Blog
export const getBlogArticles = async () => {
  const response = await api.get('/blog');
  return response.data;
};

export const getBlogArticle = async (id) => {
  const response = await api.get(`/blog/${id}`);
  return response.data;
};

// Portfolio
export const getPortfolioProjects = async () => {
  const response = await api.get('/portfolio');
  return response.data;
};

export const getAdminPortfolio = async () => {
  const response = await api.get('/admin/portfolio');
  return response.data;
};

export const createPortfolioProject = async (data) => {
  const response = await api.post('/admin/portfolio', data);
  return response.data;
};

export const updatePortfolioProject = async (id, data) => {
  const response = await api.put(`/admin/portfolio/${id}`, data);
  return response.data;
};

export const deletePortfolioProject = async (id) => {
  const response = await api.delete(`/admin/portfolio/${id}`);
  return response.data;
};

export const uploadPortfolioImage = async (projectId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/admin/portfolio/${projectId}/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deletePortfolioImage = async (projectId, imageIndex) => {
  const response = await api.delete(`/admin/portfolio/${projectId}/image/${imageIndex}`);
  return response.data;
};

export default api;
